<template>
  <div>
    <Header :isHome="false"></Header>

    <div class="featured-1" style="background-color: #fafafa; padding: 1rem">
      <!-- <div class="container expert-title">
				<img src="../../assets/imgs/export-title-icon.png" class="title-icon" style="margin-top: 1rem;">
				<div class="title-text">Appointment interface</div>
			</div> -->
      <div class="container">
        <div class="row">
          <div class="col-lg-6 align-self-center">
            <p class="text-muted">
              <span
                class="typewrite d-inline"
                data-period="2000"
                data-type='[ " Travel Blogger. ", "Content Writter. ", "Food Guides " ]'
              ></span>
            </p>
            <h2>Hello, I’m <span style="color: #09ffe2">GCI</span></h2>
            <h3 class="mb-20">I'm here to help.</h3>
            <!-- <h5 class="text-muted">THE MAN IMAGE CONTENT NEEDS TO BE PROVIDED BY THE CUSTOMER</h5> -->
            <form class="input-group form-subcriber mt-30 d-flex">
              <input
                type="text"
                class="form-control bg-white font-small"
                placeholder="Add your requirements"
                v-model="content"
              />
              <div
                class="btn btn-cyan-blue"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
                @click="showsubbox()"
              >
                Submit
              </div>
            </form>
          </div>
          <div class="col-lg-6 text-right d-lg-block">
            <img src="../../assets/imgs/expert-r.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-if="data" style="margin-bottom: 4rem">
      <div class="expert-title" style="margin-top: 4rem">
        <img src="../../assets/imgs/export-title-icon.png" class="title-icon" />
        <div class="title-text" style="font-size: 2rem">
          Subject Matter Experts
        </div>
      </div>
      <div class="expert-subtitle">
        SME from around the world provide free appointment and consultation
      </div>
      <div class="row" style="margin-top: 4rem">
        <div
          v-for="(item, index) in data.items"
          :key="index"
          class="col-3 expert-box hover-up-2 transition-normal"
          style="cursor: pointer"
          @click="expertboxshow(1, item)"
        >
          <div
            :style="{ backgroundImage: 'url(' + item.avatar + ')' }"
            class="expert-img"
          ></div>
          <div class="expert-dark">
            <img
              src="../../assets/imgs/author-group-hover.png"
              alt=""
              style="width: 2.5rem; height: 2.5rem"
            />
          </div>
          <div
            class=""
            style="
              background-color: #fff;
              border-radius: 0.2rem;
              width: 10rem;
              height: 6rem;
              box-shadow: 0px 12px 27px -15px rgba(0, 0, 0, 0.25);
              margin-top: -3rem;
              display: flex;
              flex-direction: column;
              z-index: 10;
              align-items: center;
              justify-content: center;
            "
          >
            <div class="expert-box-realname">{{ item.realName }}</div>
            <div style="margin-top: 0.5rem; font-size: 0.7rem">
              {{ item.user.country.englishName }}
            </div>
            <!-- <div style="margin-top: 0.5rem;font-size: 0.7rem;">{{item.position}}</div> -->
          </div>
        </div>
      </div>
    </div>

    <div
      style="
        position: fixed;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
      "
      v-if="expertbox == 1"
    >
      <div
        style="
          background-color: rgba(0, 0, 0, 0.9);
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: 1;
        "
      ></div>
      <div
        style="display: flex; z-index: 10"
        class="fadeInDown animated author-dialog"
      >
        <div style="" class="author-dialog-left">
          <!-- <img :src="exceptitem.avatar" style="width: 100%;height: 13.5rem;"> -->
          <div
            :style="{ backgroundImage: 'url(' + exceptitem.avatar + ')' }"
            style=""
            class="author-dialog-img"
          ></div>
          <div class="author-dialog-left-name">
            <div
              style="
                font-size: 1.5rem;
                color: #000;
                font-weight: bold;
                margin-top: 1rem;
              "
            >
              {{ exceptitem.realName }}
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                width: 8rem;
                height: 2.5rem;
                margin-top: 2rem;
                border-radius: 2rem;
                cursor: pointer;
              "
              :style="{
                backgroundColor: exceptitem.follow ? '#fff' : '#000',
                color: exceptitem.follow ? '#000' : '#fff',
              }"
              @click="changefollow(exceptitem)"
              v-text="exceptitem.follow ? 'UnFollow' : 'Follow +'"
            ></div>
          </div>
        </div>
        <div style="" class="author-dialog-right">
          <div
            style="display: flex; flex-direction: column; overflow: scroll"
            class="exceptbox"
          >
            <div style="color: #000; font-size: 1.5rem; font-weight: bold">
              <span style="border-bottom: 0.2rem solid #31ffda"
                >Personal profile</span
              >
            </div>
            <div
              style="
                color: #707070;
                font-weight: 400;
                margin-top: 1rem;
                font-size: 0.7rem;
                user-select: none;
              "
              ref="el"
            >
              {{ exceptitem.profile }}
            </div>

            <div
              style="
                color: #000;
                font-size: 1.5rem;
                font-weight: bold;
                margin-top: 1rem;
              "
              v-if="exceptitem.honour.length > 0"
            >
              <span style="border-bottom: 0.2rem solid #31ffda"
                >Industry honor</span
              >
            </div>
            <div style="display: flex; margin-top: 1rem; flex-wrap: wrap">
              <img
                :src="img"
                style="
                  width: 6rem;
                  height: 7.2rem;
                  margin-right: 1rem;
                  margin-bottom: 0.2rem;
                "
                v-for="(img, index4) in exceptitem.honour"
              />
            </div>
          </div>
          <div style="position: absolute; right: 1rem; top: 1rem">
            <img
              src="../../assets/imgs/box-close.png"
              style="width: 2rem; height: 2rem; cursor: pointer"
              @click="expertboxshow(0, {})"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      style="
        position: fixed;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
      "
      v-if="subbox == 1"
    >
      <div
        style="
          background-color: rgba(0, 0, 0, 0.9);
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: 1;
        "
        @click="subbox = false"
      ></div>
      <div
        style="display: flex; z-index: 10"
        class="fadeInDown animated author-dialog"
      >
        <div style="" class="dialog-box">
          <div style="position: absolute; right: 1rem; top: 1rem">
            <img
              src="../../assets/imgs/box-close.png"
              style="width: 1.5rem; height: 1.5rem; cursor: pointer"
              @click="subbox = false"
            />
          </div>
          <div style="font-size: 1.2rem; font-weight: bold">
            GCI Expert Appointment
          </div>
          <input
            type="text"
            v-model="contact"
            class="sub-input"
            style="margin-top: 2rem"
            placeholder="your Email or Phone"
          />
          <!-- <input type="text" v-model="content" class="sub-input" style="margin-top: 1rem;" placeholder="your Content"> -->
          <textarea
            cols="30"
            rows="10"
            class="sub-input"
            v-model="content"
            placeholder="your Content"
            style="margin-top: 1rem; height: 10rem"
          ></textarea>
          <button
            style="
              width: 100%;
              height: 3rem;
              border: none;
              background-color: #31ffda;
              font-size: 1rem;
              border-radius: 0.4rem;
              margin-top: 1rem;
              font-weight: bold;
            "
            @click="contentsubmit()"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// import axios from 'axios'
import Header from "/src/components/header.vue";
import Footer from "/src/components/footer.vue";
// import {baseUrl} from '../../assets/js/public.js'
export default {
  data() {
    return {
      data: null,

      expertbox: 0,
      content: "",
      subbox: false,
      contact: "",

      isMobile: false,
      islogin: false,
      isusserlevel: false,
      //   isuserlevel: false,
      //   默认全部都是会员
      isuserlevel: true,
    };
  },
  props: {},
  components: {
    Header,
    Footer,
  },
  filters: {},
  methods: {
    changefollow(item) {
      let params = {
        expertId: item.id,
      };
      this.request({
        method: "post",
        url: "/gci/user/expert/follow",
        data: params,
      })
        .then((res) => {
          if (res.status == 0) {
            // item.follow = !item.follow
            for (let i in this.data.items) {
              if (this.data.items[i].id == item.id) {
                this.data.items[i].follow = !this.data.items[i].follow;
              }
            }
          }
          // alert(res.msg)
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    contentsubmit() {
      if (this.content == "" || this.contact == "") {
        this.$bus.$emit("message", {
          type: 1,
          msg: "Contact information and appointment content not empty",
        });
      } else {
        let params = {
          content: this.content,
          contact: this.contact,
        };
        this.request({
          method: "post",
          url: "/gci/appointment/expert",
          data: params,
        })
          .then((res) => {
            if (res.status == 0) {
              this.subbox = false;
              this.content = "";
              this.contact = "";
              this.$bus.$emit("message", {
                type: 2,
                msg: res.msg,
              });
            } else {
              this.$bus.$emit("message", {
                type: 3,
                msg: res.msg,
              });
            }
          })
          .catch((error) => {
            console.error(error.response);
          });
      }
    },
    showsubbox() {
      if (localStorage.getItem("token")) {
        this.subbox = true;
      } else {
        // this.$bus.$emit('login', true)
        if (localStorage.getItem("isMobile") == "null") {
          this.$bus.$emit("login", true);
        } else {
          this.$router.push({ name: "mlogin", query: { type: 0 } });
        }
      }
    },
    getdata() {
      this.request({
        method: "get",
        url: "/gci/user/expert/list",
      })
        .then((res) => {
          this.data = res.data;
          this.$bus.$emit("loading", false);
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    expertboxshow(i, item) {
      // 未登录
      if (!this.islogin) {
        // 判断移动端
        if (this.isMobile) {
          this.$router.push({ name: "mlogin", query: { type: 1 } });
        } else {
          localStorage.setItem("logintype", 1);
          this.$bus.$emit("login", true);
        }
        // 判断是否是会员
      } else if (!this.isuserlevel) {
        // this.$router.push('userlevel')
        this.$bus.$emit("userleveldialog", true);
      } else {
        this.expertbox = i;
        this.exceptitem = item;
      }
    },
    handleRightClick(event) {
      event.preventDefault();
    },
  },
  created() {
    this.$bus.$emit("loading", true);
  },
  mounted() {
    localStorage.getItem("isMobile") == "null"
      ? (this.isMobile = false)
      : (this.isMobile = true);
    if (localStorage.getItem("token")) {
      this.islogin = true;
      let userinfo = JSON.parse(localStorage.getItem("user"));
      if (userinfo.vip.id != 1) {
        this.isuserlevel = true;
      }
    }
    this.getdata();
  },
};
</script>

<style scoped lang="scss">
.featured-1 {
  padding-top: 6rem !important;
}
.sub-input {
  border: none;
  background-color: #f3f5fb;
  padding: 0.5rem;
  font-size: 0.7rem;
  border-radius: 0.4rem;
  font-size: 0.9rem;
  width: 100%;
}
.author-box {
  width: 100%;
  flex-wrap: nowrap;
  overflow-x: scroll;
}
.author-box::-webkit-scrollbar {
  display: none;
}

.author-dialog {
  .author-dialog-left {
    border-radius: 1.25rem 0 0 1.25rem;
    background: #31ffda;
    width: 15rem;
    height: 30rem;
    display: flex;
    align-items: center;
    padding: 2rem;
    flex-direction: column;

    .author-dialog-left-name {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .author-dialog-img {
      background-size: cover;
      background-repeat: no-repeat;
      background-position: top center;
      width: 100%;
      height: 13.5rem;
    }
  }
  .author-dialog-right {
    border-radius: 0 1.25rem 1.25rem 0;
    background-color: #fff;
    width: 35rem;
    height: 30rem;
    display: flex;
    padding: 1.5rem;
  }
}

.expert-box-realname {
  color: #333;
  font-size: 1rem;
  font-weight: bold;
  text-align: center;
}
.expert-dark {
  background-color: rgba(82, 82, 82, 0.46);
  align-items: center;
  justify-content: center;
  width: calc(100% - 30px);
  height: 20rem;
  position: absolute;
  left: 15px;
  top: 0;
  display: none;
  border-radius: 0.2rem;
}
.expert-box {
  overflow: hidden;
  width: 100%;
  margin-bottom: 2rem;
  border-radius: 0.2rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.expert-box:hover {
  .expert-dark {
    display: flex;
  }
  .expert-box-realname {
    color: #16e1bd;
  }
}
.expert-img {
  background-position: center top;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 20rem;
  z-index: -1;
}
.expert-subtitle {
  font-size: 1.2rem;
  color: #8c8c8c;
  font-weight: 400;
  margin-top: 1rem;
  text-align: center;
}
.title-text {
  margin-left: -2rem;
}
.expert-title {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-weight: 900;
  color: #333;
  font-size: 3rem;
  margin-top: 6rem;
}
.title-icon {
  width: 3rem;
  height: 3rem;
}
.exceptbox::-webkit-scrollbar {
  display: none;
}
.dialog-box {
  background-color: #fff;
  width: 35rem;
  height: 26rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
}
@media (max-width: 767px) {
  .author-dialog {
    margin: 1rem;
    flex-direction: column;
    .author-dialog-left {
      width: 100%;
      height: 15rem;
      flex-direction: row;
      border-radius: 1.25rem 1.25rem 0 0;
      .author-dialog-left-name {
        margin-left: 1rem;
      }
      .author-dialog-img {
        height: 11rem;
      }
    }
    .author-dialog-right {
      border-radius: 0 0 1.25rem 1.25rem;
      width: 100%;
      height: 22rem;
    }
  }
  .row {
    justify-content: center;
  }
  .expert-box {
    flex: 0 0 75%;
    max-width: 100%;
  }
  .dialog-box {
    width: 20rem;
  }
}
</style>
